import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Typography } from '@mui/material';
//import './Guidelines.css'; // Move styles to an external CSS file

const Guidelines = () => {
  return (
    <div className="container-fluid">
         <div className="thematic-banner">
        <img src="/Banner 5.png" alt="Thematic Banner" style={{ width: '100%', height: '350px' }}/>
      </div> 
    <div className="container" style={{paddingBottom: '2em'}}>
        <style>
            {`
             @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
              .container-fluid {
                padding-right: 0 !important;
                padding-left: 0 !important;
              }
              .home-banner img {
                display: block;
                margin: 0 auto;
              }
              body {
                font-family: 'Roboto';
              }
            `}
        </style>
        <h3 style={{ marginBottom: "10px", color: "#009EDB",  paddingTop: '1em', paddingBottom: '5px'}}>
          User Guidelines
        </h3>
        <Typography variant="body1" paragraph sx={{textAlign: 'justify'}}>
        To calculate footprint indicators using the Global Footprint Tool (GFT), users must create a personal user workspace (account), log in, upload national data, and then download the results.
          </Typography>   
      <div className="col-12">
      <h3 style={{ marginBottom: "10px", color: "#009EDB",  paddingTop: '1em', paddingBottom: '5px'}}>
            Create an Account:
          </h3>
          <ul>
            <li>Click the  <strong>Footprint Calculator</strong> button in the upper right corner of the screen displaying the GFT.</li>
            <li>In the Footprint Calculator tab, click the  <strong>REGISTER</strong> button.</li>
            <li>Complete the registration form by providing the required details: First Name, Last Name, Institution, Country, Email Address, Username and Password.</li>           
            <li>Click the  <strong>SUBMIT</strong> button to submit the registration details.</li>
            <li>Once your information is verified, UNEP will send you a confirmation email.</li>
          </ul>
          <h3 style={{ marginBottom: "10px", color: "#009EDB",  paddingTop: '1em', paddingBottom: '5px'}}>
          Log in to your account:
          </h3>
          <ul>
            <li>Return to the Global Footprint Tool homepage.</li>
            <li>Click the <strong>Footprint Calculator</strong> button in the upper right corner of the screen.</li>
            <li>In the Footprint Calculator tab, click the <strong>LOGIN </strong>button (redirects to the login form).</li>
            <li>Enter the credentials provided in the confirmation email earlier.</li>
            <li>After successfully logging in, you will be redirected to the Global Footprint Tool Calculator homepage, where you can initiate a calculation process for footprint indicators, monitor the calculation status and download the results.</li>
          </ul>
          <Typography variant="body1" paragraph sx={{textAlign: 'justify', paddingBottom: '2em'}}>
          For more information, please refer to the <a href="https://wedocs.unep.org/items/d8757c79-c577-44b8-99a1-1c1ac3760e4d" target="_blank" rel="noopener noreferrer">Global Footprint Tool User Guide</a>.
          </Typography>
        </div>
    </div>
    </div>
  );
};

export default Guidelines;
